/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * @param {object[]} cards - card layouts
 * @param {object} layoutModel
 * @return `cards` array sorted in order of appearance in exploration
 */
function sortCards(cards, layoutModel) {
	if(cards.length < 2)	return cards;

	return layoutModel.items.filter(
		cardLayout => cards.indexOf(cardLayout) >= 0
	);
}

export {
	sortCards
};



// WEBPACK FOOTER //
// ./src/js/components/cards/actions/actionHelper.js